// @flow

import * as React from 'react';

import { TableCell, TableRow, Checkbox, IconButton } from '@mui/material';
import IconArrowRight from '@mui/icons-material/KeyboardArrowRight';
import IconArrowDown from '@mui/icons-material/KeyboardArrowDown';

class DataTableRow extends React.Component {
  handleClick = (event) => {
    this.props.onClick(event, this.props.id);
  };

  onRequestExpand = (event) => {
    this.props.onRequestExpand(event, this.props.id);
  };

  render() {
    const {
      data: n,
      columnData,
      expandable,
      isExpanded,
      selectable,
      isSelected,
      classes = {}
    } = this.props;

    return (
      <TableRow
        className={classes.root}
        hover
        onClick={this.props.onClick && this.handleClick}
        role="checkbox"
        aria-checked={isSelected}
        tabIndex={-1}
        selected={isSelected}
      >
        {selectable && (
          <TableCell padding="checkbox" style={{ width: 48 }}>
            <Checkbox checked={isSelected} />
          </TableCell>
        )}
        {expandable && (
          <TableCell padding="checkbox" style={{ width: 48 }}>
            <IconButton onClick={this.onRequestExpand}>
              {isExpanded ? <IconArrowDown /> : <IconArrowRight />}
            </IconButton>
          </TableCell>
        )}
        {columnData.map((column) => {
          const value =
            typeof column.getValue === 'function'
              ? column.getValue(n, column)
              : n[column.id.split('.')];

          const styles =
            typeof column.styles === 'function'
              ? column.styles(n, column)
              : column.styles
              ? column.styles
              : {};

          if (column.cellComponent) {
            const CellComponent = column.cellComponent;
            return (
              <CellComponent
                key={column.id}
                column={column}
                item={n}
                admin
                rowProps={this.props}
              >
                {value}
              </CellComponent>
            );
          }
          if (column.checkbox) {
            return (
              <TableCell
                key={column.id}
                padding={
                  column.disablePadding ? 'none' : column.padding || 'normal'
                }
                align={column.align}
                style={{ whiteSpace: 'pre', ...styles }}
              >
                {value}
              </TableCell>
            );
          }
          return (
            <TableCell
              key={column.id}
              padding={
                column.disablePadding ? 'none' : column.padding || 'normal'
              }
              align={column.align}
              style={{ whiteSpace: 'pre', ...styles }}
            >
              {value}
            </TableCell>
          );
        })}
      </TableRow>
    );
  }
}

export default DataTableRow;